// src/components/Topbar.jsx
import { useEffect } from "react";

export default function Topbar() {
    const toggleSidebar = () => {
        document.body.classList.toggle("sidebar-open");
    };

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") {
                document.body.classList.remove("sidebar-open");
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    return (
        <div className="topbar">
            <button
                className="hamburger"
                onClick={toggleSidebar}
                aria-label="Menü"
                type="button"
            >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                    <rect x="3" y="6" width="18" height="2" rx="1" />
                    <rect x="3" y="11" width="18" height="2" rx="1" />
                    <rect x="3" y="16" width="18" height="2" rx="1" />
                </svg>
            </button>
        </div>
    );
}
